module.exports = __webpack_public_path__ + "static/img/top_image3.9e57d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_image3.png
// module id = rWgP
// module chunks = 0